import Vue from 'vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'

import './assets/styles/variables.scss'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: 'G-9Q4FG1LLHQ' },
  enabled: false
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
